import React from 'react';
import { Flex } from '@balance-web/flex';
import { Box } from '@balance-web/box';
import type { ReactNode } from 'react';
import { Trigger } from '@radix-ui/react-collapsible';
import { ChevronDownIcon, ChevronUpIcon } from '@balance-web/icon';
import { IconButton } from '@balance-web/button';
import { theme } from '@balance-web/theme';

import { useCollapsableContext } from './context';

type CollapsableHeaderProps = {
  children: ReactNode;
};

export const CollapsableHeader = ({ children }: CollapsableHeaderProps) => {
  const context = useCollapsableContext();

  // Whole header would toggle open state
  if (context.triggerTarget === 'header') {
    return (
      <Trigger asChild>
        <Flex
          alignItems="center"
          css={{
            ':hover': {
              // tokenise when new theme is ready.
              background: theme.primitives.colour.neutral.k98,
              borderTopLeftRadius: theme.radii.large,
              borderTopRightRadius: theme.radii.large,
              borderBottomLeftRadius: context.isOpen ? 0 : theme.radii.large,
              borderBottomRightRadius: context.isOpen ? 0 : theme.radii.large,
            },
          }}
          cursor="pointer"
          gap="large"
          paddingX="xlarge"
          paddingY="large"
        >
          <Box flex="1">{children}</Box>
          <Flex justifyContent="flex-end" minWidth={55}>
            {context.trigger ? (
              context.trigger
            ) : context.isOpen ? (
              <ChevronUpIcon color="active" />
            ) : (
              <ChevronDownIcon color="active" />
            )}
          </Flex>
        </Flex>
      </Trigger>
    );
  }

  return (
    <Flex alignItems="center" gap="large" paddingX="xlarge" paddingY="large">
      <Box flex="1">{children}</Box>
      {/* Only icon would toggle open state */}
      <Trigger asChild>
        {context.trigger ? (
          context.trigger
        ) : (
          <IconButton
            icon={context.isOpen ? ChevronUpIcon : ChevronDownIcon}
            label="Toggle"
            size="small"
            variant="text"
          />
        )}
      </Trigger>
    </Flex>
  );
};
